import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { EditorialMarquee } from "./components/EditorialMarquee";
import { Manifesto } from "./components/Manifesto";
import { Services } from "./components/Services";
import { Stats } from "./components/Stats";
import { Gallery } from "./components/Gallery";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import PrivacyPolicy from "./pages/PrivacyPolicy";

const Landing = () => (
  <>
    <Nav />
    <main>
      <Hero />
      <EditorialMarquee />
      <Manifesto />
      <Services />
      <Stats />
      <Gallery />
      <ContactSection />
    </main>
    <Footer />
    <WhatsAppButton />
  </>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-[#F4F4F0] text-[#0E0E0E] min-h-screen antialiased">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" toastOptions={{ style: { borderRadius: 0, border: "1px solid #0E0E0E", fontFamily: "'IBM Plex Mono', monospace" } }} />
    </div>
  );
}

export default App;
